export function impactFeedbackProgress(remaining: number, duration: number): number {
  if (!Number.isFinite(remaining) || remaining < 0) {
    throw new RangeError('impact cue remaining time must be finite and non-negative')
  }
  if (!Number.isFinite(duration) || duration <= 0) {
    throw new RangeError('impact cue duration must be finite and positive')
  }

  return Math.min(1, Math.max(0, 1 - remaining / duration))
}

export function impactFeedbackFrameDelta(dt: number): number {
  if (!Number.isFinite(dt) || dt < 0) {
    throw new RangeError('impact feedback frame delta must be finite and non-negative')
  }
  return dt
}
